import { gql, useMutation } from '@apollo/client';
import { User } from './useUserQuery';

const UPDATE_USER_NAVSTATE = gql`
  mutation UpdateUserNavState($navState: String!) {
    updateUserNavState(navState: $navState) {
      id
      navState
    }
  }
`;

export interface UpdateUserNavStateResult {
  updateUserNavState: User;
}

export interface UpdateUserNavStateInput {
  navState: string;
}

export function useUserUpdateNavStateMutation() {
  return useMutation<UpdateUserNavStateResult, UpdateUserNavStateInput>(UPDATE_USER_NAVSTATE, {
    update(cache, { data }) {
      if (data?.updateUserNavState) {
        cache.writeFragment({
          id: cache.identify({ __typename: 'User', id: data.updateUserNavState.id }),
          fragment: gql`
            fragment NavStateUpdate on User {
              navState
            }
          `,
          data: {
            navState: data.updateUserNavState.navState,
          },
        });
      }
    },
  });
}
